import { render, staticRenderFns } from "./StudioProductPlaylists.vue?vue&type=template&id=931aea0e&"
import script from "./StudioProductPlaylists.vue?vue&type=script&lang=js&"
export * from "./StudioProductPlaylists.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductPlaylists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports